// verificationSeal.js — E2 (super-marathon) PURE derive of the verification SEAL.
//
// The spine already carries the oracle's verdicts OUT of the loop on the `auto_correct`
// event (result.verdicts, each { verifier, passed, evidence }) — see loop/oracleGate.js.
// Rather than grow the spine (its dp/loc ratchet is a hard ceiling), the SEAL is DERIVED
// here from that existing result, keeping runLocalAgentLoopInner byte-identical. Pure:
// no I/O, no globals — trivially unit-testable and safe to import anywhere.

/**
 * @typedef {{ reachedGreen: boolean, noVerifiers: boolean,
 *   verifiers: { name: string, passed: boolean }[] }} VerificationReport
 */

/**
 * Build the seal shape from an `auto_correct` event's result (or null if it carries no
 * verdicts — nothing to seal). `noVerifiers` is derived honestly: an empty verdict list
 * means no executable verifier ran.
 * @param {{ reachedGreen?: boolean, verdicts?: { verifier?: string, passed?: boolean }[] } | null | undefined} result
 * @returns {VerificationReport | null}
 */
export function deriveVerificationReport(result) {
  if (!result || !Array.isArray(result.verdicts)) return null;
  const verifiers = result.verdicts.map((v) => ({ name: String(v?.verifier ?? ''), passed: !!v?.passed }));
  return {
    reachedGreen: !!result.reachedGreen,
    noVerifiers: verifiers.length === 0,
    verifiers,
  };
}
